import Default from "layouts/auth/types/Default";
import { useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import env from "variables/config";

function AccessCodePage() {
    const [searchParams] = useSearchParams();
    const [accessCode, setAccessCode] = useState((searchParams.get("trial_acces") ?? "").trim().toUpperCase());
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = () => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate("/auth/login");
            return;
        }
        setLoading(true);
        axios
            .post(
                `${env.apiUrl}/auth/validate-access-code`,
                { accessCode },
                { headers: { Authorization: `Bearer ${token}` } }
            )
            .then((res: any) => {
                localStorage.setItem("accessCodeValidated", "true");
                // A premium code subscribes the account; a trial code sets its end date
                localStorage.setItem("isSub", String(!!res.data?.isSub));
                localStorage.setItem("trialEndsAt", res.data?.trialEndsAt ?? "");
                navigate("/");
            })
            .catch(() => {
                toast.error("Code d'accès invalide.");
            })
            .finally(() => setLoading(false));
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter") handleSubmit();
    };

    return (
        <Default
            maincard={
                <div className="flex h-full w-full items-center justify-center">
                    <div className="w-full max-w-sm flex flex-col">
                        <ToastContainer />

                        {/* Header */}
                        <div className="mb-7">
                            <h1 className="text-[1.6rem] font-semibold tracking-tight text-gray-900 mb-1.5">
                                Code d'accès
                            </h1>
                            <p className="text-sm text-gray-500">
                                Saisissez votre code d'accès pour activer votre compte.
                            </p>
                        </div>

                        {/* Access code */}
                        <div className="flex flex-col gap-1.5 mb-6">
                            <label className="text-sm font-medium text-gray-700">
                                Code d'accès
                            </label>
                            <input
                                type="text"
                                placeholder="••••••••••••"
                                className="w-full px-3.5 py-3 rounded-md border border-gray-200 bg-white text-gray-900 placeholder-gray-400 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-colors duration-150"
                                value={accessCode}
                                onChange={(e) => setAccessCode(e.target.value)}
                                onKeyDown={handleKeyDown}
                                autoFocus
                            />
                        </div>

                        {/* CTA */}
                        <button
                            disabled={loading}
                            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-md transition-colors duration-150 text-[15px] disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={handleSubmit}
                        >
                            {loading ? (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                                    </svg>
                                    Vérification...
                                </span>
                            ) : (
                                "Activer mon compte"
                            )}
                        </button>
                    </div>
                </div>
            }
        />
    );
}

export default AccessCodePage;
